<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1200"
    @click:outside="clickOutside"
  >
    <template v-slot:activator="{ attrs }">
      <p id="billingPayreqForm" v-bind="attrs" @click="openForm"></p>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5" style="margin: auto"
          >FORMULIR PAYMENT REQUEST (<span v-if="form != null">{{
            form.app_category != 2 ? 'CA' : 'BILL'
          }}</span
          >)</span
        >
      </v-card-title>
      <v-form
        v-if="form != null"
        ref="formPayreq"
        :disabled="loading"
        lazy-validation
        @submit.prevent="saveForm"
        style="position: relative"
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" class="d-flex flex-row">
                <v-row>
                  <v-col cols="2">
                    <p
                      class="text-left"
                      style="
                        margin: 0 10px 0 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                        padding: 0;
                      "
                    >
                      Jenis Formulir
                    </p>
                  </v-col>
                  <v-col cols="10">
                    <div
                      class="d-flex align-center"
                      style="
                        height: 28px;
                        position: relative;
                        margin: 0 0 0 10px;
                      "
                    >
                      <v-radio-group
                        v-model="form.app_category"
                        mandatory
                        :column="false"
                        @change="formTypeWatcher"
                        :disabled="isBill"
                      >
                        <v-row>
                          <v-col v-if="!isBill" cols="6">
                            <div class="d-flex" style="width: 120px">
                              <v-radio :value="1"></v-radio>
                              <p style="margin: 0; font-size: 12px">
                                Payreq CA
                              </p>
                            </div>
                          </v-col>
                          <v-col v-if="isBill" cols="6">
                            <div class="d-flex" style="width: 120px">
                              <v-radio :value="2"></v-radio>
                              <p style="margin: 0; font-size: 12px">
                                Payreq Bill
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-radio-group>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="form.app_category == 2"
                cols="12"
                class="d-flex flex-row"
              >
                <v-row>
                  <v-col cols="2">
                    <p
                      style="
                        margin: 0 10px 0 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Gunakan Payreq Existing
                    </p>
                  </v-col>
                  <v-col cols="2">
                    <v-checkbox
                      v-model="form.add_to_existing"
                      style="margin: 0 0 0 10px; height: 25px; padding: 0"
                    ></v-checkbox>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row v-if="form.add_to_existing">
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      padding: 0;
                    "
                  >
                    Cari payment request
                  </p>
                </div>
                <div
                  class="d-flex"
                  style="margin: 0; padding: 0; position: relative"
                >
                  <v-autocomplete
                    v-model="form.payment_request_id"
                    :items="dropdown.payreq"
                    :search-input.sync="searchPayreq"
                    :rules="rules.payreq"
                    :item-text="'document_no'"
                    item-value="id"
                    placeholder="Ketik nomor dokumen lalu enter"
                    style="font-size: 12px; height: 45px"
                    return-id
                    dense
                    outlined
                    clearable
                    @keydown.enter.prevent="payreqQuerySelections(searchPayreq)"
                    :loading="payreqLoading"
                    @change="payreqWatcher"
                  ></v-autocomplete>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="!form.add_to_existing">
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Pemohon
                </p>

                <v-text-field
                  :value="form.employee.name"
                  disabled
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Perusahaan
                </p>
                <v-autocomplete
                  v-model="form.company"
                  :items="dropdown.plant"
                  :rules="rules.companyRules"
                  item-text="name"
                  item-value="id"
                  return-object
                  outlined
                  dense
                  style="font-size: 12px; height: 45px"
                  clearable
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Department
                </p>

                <v-text-field
                  :value="form.department.name"
                  disabled
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                />
              </v-col>
              <v-col md="3" class="d-flex flex-column"></v-col>

              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Jenis Payment Request
                </p>

                <v-autocomplete
                  v-model="form.payreq_type"
                  :items="dropdown.payreq_type"
                  :rules="rules.payreq_type"
                  item-text="name"
                  item-value="id"
                  style="font-size: 12px; height: 45px"
                  return-id
                  dense
                  outlined
                  clearable
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                      padding: 0;
                    "
                  >
                    Pilih Vendor / Dibayarkan Kepada
                  </p>
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.vendor_type"
                      mandatory
                      :column="false"
                    >
                      <div class="mr-3 d-flex">
                        <v-radio value="1"></v-radio>
                        <p style="margin: 0; font-size: 12px">
                          Dari eCatalogue
                        </p>
                      </div>
                      <div class="d-flex">
                        <v-radio value="0"></v-radio>
                        <p style="margin: 0; font-size: 12px">Tulis Manual</p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
                <div
                  class="d-flex"
                  style="margin: 0; padding: 0; position: relative"
                >
                  <v-autocomplete
                    v-if="form.vendor_type == 1"
                    v-model="form.vendor"
                    :items="dropdown.vendor"
                    :search-input.sync="searchVendor"
                    :rules="rules.vendor"
                    item-text="name"
                    item-value="code"
                    placeholder="Cari nama vendor"
                    style="font-size: 12px; height: 45px"
                    return-object
                    dense
                    outlined
                    clearable
                    @change="vendorWatcher"
                    @keydown.enter.prevent
                  ></v-autocomplete>
                  <v-text-field
                    v-if="form.vendor_type == 0"
                    v-model="form.vendor_name"
                    :rules="rules.vendor_name"
                    dense
                    outlined
                    placeholder="Ketik nama vendor"
                    style="font-size: 12px; height: 45px"
                    @keydown.enter.prevent
                  />
                </div>
              </v-col>

              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Jenis Pembayaran
                </p>

                <v-autocomplete
                  v-model="form.payment_type"
                  :items="dropdown.payment_type"
                  :rules="rules.payment_type"
                  item-text="name"
                  item-value="id"
                  style="font-size: 12px; height: 45px"
                  return-id
                  dense
                  outlined
                  clearable
                  @keydown.enter.prevent
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <div
                  class="d-flex flex-column"
                  v-if="form.payment_type != 1 && form.payment_type != null"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama Bank *
                  </p>

                  <v-text-field
                    v-model="form.bank_name"
                    :rules="rules.bank_name"
                    dense
                    outlined
                    style="font-size: 12px; height: 45px"
                    @keydown.enter.prevent
                  />
                </div>
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <div
                  class="d-flex flex-column"
                  v-if="form.payment_type != 1 && form.payment_type != null"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No. Rekening *
                  </p>

                  <v-text-field
                    v-model="form.account_number"
                    :rules="rules.account_number"
                    dense
                    outlined
                    style="font-size: 12px; height: 45px"
                    @keydown.enter.prevent
                  />
                </div>
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <div
                  class="d-flex flex-column"
                  v-if="form.payment_type != 1 && form.payment_type != null"
                >
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Atas nama *
                  </p>

                  <v-text-field
                    v-model="form.account_name"
                    :rules="rules.account_name"
                    dense
                    outlined
                    style="font-size: 12px; height: 45px"
                    @keydown.enter.prevent
                  />
                </div>
              </v-col>

              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Sumber Dana
                </p>

                <v-text-field
                  v-model="form.source_of_funds"
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="9" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Untuk Pembayaran
                </p>

                <v-text-field
                  v-model="form.payment_desc"
                  dense
                  outlined
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
            </v-row>
            <v-row v-if="form.app_category != 2">
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Currency
                </p>

                <v-autocomplete
                  v-model="form.currency"
                  :items="dropdown.currency"
                  outlined
                  item-text="code"
                  item-value="id"
                  hide-details
                  hide-no-data
                  return-object
                  style="margin: 0"
                  dense
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Biaya Pengiriman
                </p>

                <v-text-field
                  v-model="form.delivery_costs"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Biaya Layanan
                </p>

                <v-text-field
                  v-model="form.service_costs"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Biaya Lain-lain
                </p>

                <v-text-field
                  v-model="form.other_costs"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Disc Global (%)
                </p>

                <v-text-field
                  v-model="form.global_discount_percent"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @change="globalPercentWatcher"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Disc Global (num)
                </p>

                <v-text-field
                  v-model="form.global_discount"
                  @change="globalAmountWatcher"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  PPh (%)
                </p>

                <v-text-field
                  v-model="form.pph_percent"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @change="pphPercentWatcher"
                  @keydown.enter.prevent
                />
              </v-col>
              <v-col cols="12" md="3" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  PPh (nominal)
                </p>

                <v-text-field
                  v-model="form.pph_amount"
                  @change="pphAmountWatcher"
                  dense
                  outlined
                  type="number"
                  min="0"
                  style="font-size: 12px; height: 45px"
                  @keydown.enter.prevent
                />
              </v-col>
            </v-row>

            <div style="margin-top: 20px">
              <v-btn
                v-if="!isBill"
                rounded
                small
                elevation="1"
                color="indigo"
                class="white--text mr-2"
                style="font-size: 12px; margin-bottom: 5px"
                @click.stop="addNewItem"
                :disabled="!form.company"
              >
                + Item
              </v-btn>
              <!-- <v-btn
                rounded
                small
                elevation="1"
                color="indigo"
                class="white--text"
                style="font-size: 12px; margin-bottom: 5px"
                @click.stop="importBillingData"
              >
                Import
                <v-icon size="15" style="margin-left: 5px">
                  mdi-file-import-outline
                </v-icon>
              </v-btn> -->
              <v-data-table
                max-height="50vh"
                mobile-breakpoint="0"
                style="cursor: pointer; border: 1px solid rgba(0, 0, 0, 0.2)"
                :headers="payreqHeaders"
                :items="form.payment_request_detail"
                :items-per-page="10"
                item-key="id"
              >
                <template v-slot:[`header.action`]>
                  <span style="margin-top: 5px">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ attrs, on }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          color="red lighten-2"
                          x-small
                          @click="deleteAll"
                          :disabled="form.payment_request_detail.length == 0"
                        >
                          mdi-delete-circle
                        </v-icon>
                      </template>
                      <span>Delete All</span>
                    </v-tooltip>
                  </span>
                </template>
                <template v-slot:[`item.action`]="{ index }">
                  <div
                    style="
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    <v-btn
                      icon
                      x-small
                      @click.stop="deleteItem(index)"
                      style="margin-right: 5px"
                    >
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </div>
                </template>
                <template v-slot:[`item.no`]="{ index }">
                  <div style="width: 35px">
                    {{ index + 1 }}
                  </div>
                </template>
                <!-- BILL -->
                <template v-slot:[`item.total_after_tax`]="{ item }">
                  <div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.total_after_tax"
                      :readonly="payment_request_detail == undefined"
                      type="number"
                      min="0"
                      dense
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.deduction`]="{ item }">
                  <div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.deduction"
                      :readonly="payment_request_detail == undefined"
                      type="number"
                      min="0"
                      dense
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.debt_value`]="{ item }">
                  <div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      :value="
                        Math.round(
                          parseFloat(item.total_after_tax) -
                            parseFloat(item.deduction)
                        )
                      "
                      readonly
                      dense
                      type="number"
                      min="0"
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.invoice_due_date`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.invoice_due_date }}
                  </div>
                </template>
                <template v-slot:[`item.receive_invoice_date`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.receive_invoice_date }}
                  </div>
                </template>
                <template v-slot:[`item.invoice_date`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.invoice_date }}
                  </div>
                </template>
                <template v-slot:[`item.invoice_no`]="{ item }">
                  <div style="width: 135px; font-size: 12px">
                    {{ item.invoice_no }}
                  </div>
                </template>
                <template v-slot:[`item.odoo_bill_no`]="{ item }">
                  <div style="width: 135px; font-size: 12px">
                    {{ item.odoo_bill_no }}
                  </div>
                </template>
                <!-- CA -->
                <template v-slot:[`item.product_code`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.product_code }}
                  </div>
                </template>
                <template v-slot:[`item.product_name`]="{ item }">
                  <div style="width: 210px; font-size: 12px">
                    {{ item.product_name }}
                  </div>
                </template>
                <template v-slot:[`item.qty_demand`]="{ item }">
                  <div style="width: 65px; font-size: 12px">
                    {{ item.qty_demand }}
                  </div>
                </template>
                <template v-slot:[`item.qty_paid`]="{ item }">
                  <div style="width: 65px; font-size: 12px">
                    {{ item.qty_paid }}
                  </div>
                </template>
                <template v-slot:[`item.qty_request`]="{ item }">
                  <div
                    style="
                      width: 95px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.qty_request"
                      type="number"
                      :min="0"
                      :max="item.qty_demand - item.qty_paid"
                      dense
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.uom`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.uom_name }}
                  </div>
                </template>
                <template v-slot:[`item.price_request`]="{ item }">
                  <div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.price_request"
                      type="number"
                      dense
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.discount_percent`]="{ item }">
                  <div
                    style="
                      width: 125px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.discount_percent"
                      :disabled="
                        item.discount_amount != null &&
                        item.discount_amount != 0
                      "
                      type="number"
                      min="0"
                      dense
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.discount_amount`]="{ item }">
                  <div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-text-field
                      v-model="item.discount_amount"
                      :disabled="
                        item.discount_percent != null &&
                        item.discount_percent != 0
                      "
                      dense
                      type="number"
                      min="0"
                      outlined
                      style="margin: 0"
                    />
                  </div>
                </template>
                <template v-slot:[`item.tax_type`]="{ item }"
                  ><div
                    style="
                      width: 135px;
                      height: 45px;
                      font-size: 12px;
                      margin-top: 3px;
                    "
                  >
                    <v-autocomplete
                      v-model="item.tax_type"
                      :items="dropdown.tax"
                      item-text="name"
                      item-value="id"
                      style="font-size: 12px; height: 45px"
                      return-id
                      dense
                      outlined
                      clearable
                    ></v-autocomplete>
                  </div>
                </template>
              </v-data-table>
            </div>
            <FormImportBilling @saveBillingItem="saveBillingItem" />
            <FormItem
              :act="'add'"
              :detail="form"
              :itemDetail="null"
              :proc="proc"
              @closeForm="closeFormAddItem"
              :dropdownVendor="dropdown.vendor"
            />
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div style="padding: 0 25px 20px; width: 100%">
            <v-btn
              type="submit"
              style="width: 100%"
              color="blue darken-1"
              class="white--text"
              :loading="loading"
            >
              SIMPAN
            </v-btn>
            <v-btn
              style="width: 100%; margin-top: 15px"
              color="pink"
              class="white--text"
              @click="closeDialog"
              :loading="loading"
            >
              BATAL
            </v-btn>
          </div>
          <!-- <v-btn color="blue darken-1" text type="submit"> Save </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import { companyCodeMixin } from '../../../mixin/companyCode'
export default {
  name: 'FormPayreq',
  props: ['payment_request_detail', 'dropdownUnit', 'isBill'],
  mixins: [companyCodeMixin],
  components: {
    FormImportBilling: () => import('./components/ImportForm.vue'),
    FormItem: () => import('./ItemForm.vue')
  },
  data() {
    return {
      proc: buildType.apiURL('proc'),
      eSanqua: buildType.apiURL('esanqua'),
      loading: false,
      dialog: false,
      form: null,
      dropdown: {
        payment_type: [
          {
            id: 1,
            name: 'Tarik Tunai BDC'
          },
          {
            id: 2,
            name: 'Bank'
          }
        ],
        payreq_type: [
          {
            id: 1,
            name: 'CA'
          },
          {
            id: 2,
            name: 'Reimburst'
          },
          {
            id: 4,
            name: 'Petty cash'
          },
          {
            id: 3,
            name: 'Lain-lain'
          }
        ],
        tax: [
          {
            id: 6,
            name: 'PPn 12% Inc'
          },
          {
            id: 7,
            name: 'PPn 12% Exc'
          }
          // {
          //   id: 5,
          //   name: 'PPh 22 (0,3%)'
          // }
        ],
        vendor: [],
        plant: [],
        payreq: [],
        unit: [],
        currency: []
      },
      searchVendor: null,
      selectedVendor: null,
      searchPayreq: null,
      selectedPayreq: null,
      payreqLoading: false,
      rules: {
        payment_type: [],
        payreq_type: [],
        vendor: [],
        payreq: [],
        vendor_name: [],
        bank_name: [],
        account_name: [],
        account_number: [],
        companyRules: []
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    payreqHeaders() {
      const arrHeaders = []
      arrHeaders.push(
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        },
        {
          text: 'No',
          value: 'no',
          align: 'left'
          // sortable: true,
        }
      )
      if (this.form.app_category != 2) {
        arrHeaders.push(
          {
            text: 'Kode Barang',
            value: 'product_code',
            align: 'left'
            // sortable: false,
          },
          {
            text: 'Nama Barang',
            value: 'product_name',
            align: 'left'
            // sortable: false,
          },
          {
            text: 'Qty Fpb',
            value: 'qty_demand',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          // {
          //   text: 'Qty Dibayar',
          //   value: 'qty_paid',
          //   align: 'left',
          //   // sortable: true,
          //   sortable: false
          // },
          {
            text: 'Qty Request',
            value: 'qty_request',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Unit',
            value: 'uom',
            align: 'left',
            sortable: false
          },
          {
            text: 'Harga',
            value: 'price_request',
            align: 'left',
            sortable: false
          },
          {
            text: 'Disc (%)',
            value: 'discount_percent',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Disc Amount',
            value: 'discount_amount',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Tax',
            value: 'tax_type',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Total',
            value: 'price_total',
            align: 'left',
            // sortable: true,
            sortable: false
          }
        )
      }
      if (this.form.app_category == 2) {
        arrHeaders.push(
          {
            text: 'Invoice No.',
            value: 'invoice_no',
            align: 'left'
            // sortable: false,
          },
          {
            text: 'Bill No.',
            value: 'odoo_bill_no',
            align: 'left'
            // sortable: false,
          },
          {
            text: 'Tgl. Invoice',
            value: 'invoice_date',
            align: 'left',
            sortable: false
          },
          {
            text: 'Tgl. Faktur Terima',
            value: 'receive_invoice_date',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Tgl. Jatuh Tempo',
            value: 'invoice_due_date',
            align: 'left',
            // sortable: true,
            sortable: false
          },
          {
            text: 'Nilai Faktur',
            value: 'total_after_tax',
            align: 'left',
            sortable: false
          },
          {
            text: 'Potongan',
            value: 'deduction',
            align: 'left',
            sortable: false
          },
          {
            text: 'Hutang',
            value: 'debt_value',
            align: 'left',
            // sortable: true,
            sortable: false
          }
        )
      }
      // if (this.detail.status.id === 0) {
      return arrHeaders
      // }
    }
  },
  watch: {
    searchVendor(val) {
      if (val !== '') {
        val && val !== this.selectedVendor && this.querySelections(val)
      } else {
        this.selectedVendor = null
        this.dropdown.vendor = []
      }
    },
    // searchPayreq(val) {
    //   if (val !== '') {
    //     val && val !== this.selectedPayreq && this.payreqQuerySelections(val)
    //   } else {
    //     this.selectedPayreq = null
    //     this.dropdown.payreq = []
    //   }
    // },
    'form.vendor_type'() {
      if (this.form != null) {
        console.log('herree 10')
        if (this.payment_request_detail == undefined) {
          this.form.vendor = null
          this.form.vendor_name = null
        }
      }
    },
    'form.add_to_existing'(v) {
      if (this.form != null) {
        if (this.form.add_to_existing) {
          if (v) {
            Object.assign(this.form, {
              payment_request_id: null,
              company: null
            })
          } else {
            delete this.form.payment_request_id
          }
        }
      }
    }
  },
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(
      pModalType,
      pStatusMsg,
      pBtnCancel,
      pInputType,
      pInputAtt,
      yesBtn,
      noBtn,
      pText
    ) {
      const title =
        pInputType === 'file'
          ? 'Upload bukti approvement pada kolom dibawah'
          : ''

      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            input: pInputType !== undefined ? pInputType : null,
            inputLabel: pInputType !== undefined ? title : null,
            inputAttributes: pInputAtt !== undefined ? pInputAtt : null,
            confirmButtonText: yesBtn || 'Yes',
            cancelButtonText: noBtn || 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    getDropdownCurrency() {
      axios
        .get(`${this.proc}master/currency/drop_down?keyword=`)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.currency = res.data.data
          } else {
            this.dropdown.currency = []
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    payreqWatcher() {
      if (
        this.form.app_category == 2 &&
        this.form.add_to_existing &&
        this.form.payment_request_id
      ) {
        console.log('yessss')
        const xDetailPayreq = this.dropdown.payreq.find(
          ({ id }) => id == this.form.payment_request_id
        )
        console.log('xDetailPayreq', xDetailPayreq)
        const newComp = {
          id: xDetailPayreq.company_id,
          name: xDetailPayreq.company_name
        }
        this.form.company = newComp
      }
    },
    addNewItem() {
      setTimeout(() => {
        document.getElementById('payreqItemForm').click()
      }, 300)
    },
    deleteAll() {
      if (this.form.payment_request_detail.length > 0) {
        this.showMsgDialog(
          'question',
          'Anda yakin ingin menghapus semua item dibawah ini ?',
          true
        ).then((res) => {
          if (res.isConfirmed) {
            this.form.payment_request_detail = []
          }
        })
      } else {
        this.showMsgDialog('warning', 'Tidak ada item untuk dihapus', false)
      }
    },
    deleteItem(index) {
      this.form.payment_request_detail.splice(index, 1)
    },
    async dropdownPlant() {
      await axios
        .get(`${this.eSanqua}master/universal/plant/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.plant = res.data.data)
          }
          return (this.dropdown.plant = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.plant = [])
        })
    },
    async importBillingData() {
      setTimeout(() => {
        document.getElementById('billingFormImport').click()
      }, 200)
    },
    saveBillingItem(data) {
      console.log('hereee???>>>')
      if (data) {
        if (
          this.form.payment_request_detail != undefined &&
          this.form.payment_request_detail != null
        ) {
          for (let i = 0; i < data.length; i++) {
            this.form.payment_request_detail.push(data[i])
          }
        }
      }
    },
    saveItem(data) {
      console.log('saveItem???>>>', data)

      if (data) {
      }
    },
    vendorWatcher(v) {
      // getVendorDetail
      if (this.form.vendor) {
        const url = `${this.proc}vendor/detail/${this.form.vendor.id}`
        axios
          .get(url)
          .then((res) => {
            // this.loading = false
            console.log('vendorWatcher', res)
            if (res.data.status_code === '00') {
              this.form.account_name = res.data.data.finance_account_name
              this.form.account_number = res.data.data.finance_account_no
              this.form.bank_name = res.data.data.finance_bank_name
            }
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    async querySelections(v) {
      const url = `${this.proc}vendor/dropdown?keyword=${v}&offset=0&limit=10&order_by=name&order_type=asc`
      // if (this.form.department !== null) {
      //   url = url + `&department_parent_id=${this.form.department.id}`
      // }
      await axios
        .get(url)
        .then((res) => {
          // this.loading = false
          if (res.data.status_code === '00') {
            const resArr = []
            for (let i = 0; i < res.data.data.length; i++) {
              resArr.push({
                id: res.data.data[i].id,
                code: res.data.data[i].code,
                name: res.data.data[i].name
              })
            }
            return (this.dropdown.vendor = resArr)
          } else {
            return (this.dropdown.vendor = [])
          }
        })
        .catch((err) => {
          this.dropdown.vendor = []
          return console.log(err)
        })
    },
    payreqQuerySelections(v) {
      this.payreqLoading = true
      const url = `${this.proc}payreq/list?keyword=${v}&offset=0&limit=10`
      axios
        .get(url)
        .then((res) => {
          this.payreqLoading = false
          // this.loading = false
          if (res.data.status_code === '00') {
            const resArr = res.data.data
            return (this.dropdown.payreq = resArr)
          }
          return (this.dropdown.payreq = [])
        })
        .catch((err) => {
          this.dropdown.payreq = []
          this.payreqLoading = false
          return console.log(err)
        })
    },
    async openForm() {
      this.getDropdownCurrency()
      await this.dropdownPlant()
      console.log('user>>', this.getUserProfile)
      let appCategory = 1
      let payreqType = 1
      let xCompany = {
        id: Number(this.getUserProfile.employee.company.id),
        name: this.getUserProfile.employee.company.name
      }
      let xPareqDetails = null
      let xVendor = null
      let xVendorName = null
      console.log('openFormBilling>>>.', this.payment_request_detail)
      if (this.payment_request_detail != undefined) {
        xPareqDetails = this.payment_request_detail
      }
      console.log('xPareqDetails>>>.', xPareqDetails)

      if (this.isBill) {
        appCategory = 2
        payreqType = 3
        if (xPareqDetails) {
          xCompany = this.dropdown.plant.find(
            ({ id }) => id == xPareqDetails[0].company_id
          )
          await this.querySelections(xPareqDetails[0].vendor_code)
          xVendorName = xPareqDetails[0].vendor_name
          xVendor = this.dropdown.vendor.find(
            ({ code }) => code == xPareqDetails[0].vendor_code
          )
          // this.selectedVendor = xVendor
        }
      }
      const xPayload = {
        act: 'add_batch_in_item',
        // form_type: 'ca',
        add_to_existing: false,
        // purchase_request_id: null,
        employee: {
          id: this.getUserProfile.employee.id,
          name: this.getUserProfile.employee.name
        },
        company: xCompany,
        department: {
          id: this.getUserProfile.employee.department.id,
          name: this.getUserProfile.employee.department.name
        },
        payment_type: null,
        payreq_type: payreqType,
        vendor_type: 1,
        vendor: xVendor,
        vendor_name: xVendorName,
        account_name: null,
        account_number: null,
        bank_name: null,
        source_of_funds: null,
        payment_desc: null,
        payment_request_detail: [],
        app_category: appCategory,
        status: 0,
        directAdd: true,
        select_from_catalogue: 1,
        currency: null
      }
      console.log('formm 6>>>.', xPayload)
      this.form = xPayload
      if (xPareqDetails != null) {
        this.vendorWatcher()
        this.form.payment_request_detail = xPareqDetails
      }

      // this.form = objForm
      setTimeout(() => {
        this.dialog = true
      }, 500)
    },
    clickOutside() {
      //   this.closeDialog()
    },
    closeFormAddItem(data) {
      console.log('closeFormAddItemStart', data)
      if (data) {
        this.form.payment_request_detail.push(data)
      }
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      setTimeout(() => {
        this.form = null
        this.dropdown.plant = []
        this.dropdown.payreq = []
        this.dropdown.currency = []
        this.$emit('closeFormPayreq', 'close')
      }, 200)
    },
    saveForm() {
      if (!this.form.add_to_existing) {
        this.rules.payreq_type = [(v) => !!v || 'Wajib diisi']
        this.rules.payment_type = [(v) => !!v || 'Wajib diisi']
        this.rules.companyRules = [(v) => !!v || 'Wajib diisi']
        if (this.form.vendor_type == 1) {
          this.rules.vendor = [(v) => !!v || 'Wajib diisi']
        } else if (this.form.vendor_type == 0) {
          this.rules.vendor_name = [(v) => !!v || 'Wajib diisi']
        }

        if (this.form.payment_type != 1) {
          this.rules.bank_name = [(v) => !!v || 'Wajib diisi']
          this.rules.account_name = [(v) => !!v || 'Wajib diisi']
          this.rules.account_number = [(v) => !!v || 'Wajib diisi']
        }
      } else {
        this.rules.payreq = [(v) => !!v || 'Wajib diisi']
      }
      const self = this
      setTimeout(function () {
        if (self.$refs.formPayreq.validate()) {
          self.createNewForm()
        }
      })
    },
    createNewForm() {
      if (this.form.app_category == 2) {
        let xCompany = null
        if (this.form.company_id) {
          xCompany = this.form.company_id
        } else {
          xCompany = this.form.company.id
        }
        const xCheckInvCompId = this.form.payment_request_detail.find(
          ({ company_id }) => company_id != xCompany
        )
        console.log('xCheckInvCompId>>>', xCheckInvCompId)
        if (xCheckInvCompId != undefined) {
          return this.showMsgDialog(
            'warning',
            `${xCheckInvCompId.invoice_no} bukan milik ${this.form.company.name}`,
            false
          )
        }
      }

      const newForm = {
        payment_request_detail: this.form.payment_request_detail
      }

      if (this.form.add_to_existing) {
        Object.assign(newForm, {
          payment_request_id: this.form.payment_request_id
        })

        this.addToExistingPayreq(newForm)
      } else {
        Object.assign(newForm, {
          act: this.form.act,
          app_category: this.form.app_category,
          // purchase_request_id: this.form.purchase_request_id,
          employee_id: this.form.employee.id,
          employee_name: this.form.employee.name,
          company_id: this.form.company.id,
          company_code: this.getCompanyCode(this.form.company.id),
          company_name: this.form.company.name,
          department_id: this.form.department.id,
          department_name: this.form.department.name,
          payment_type: this.form.payment_type,
          account_name: this.form.account_name,
          account_number: this.form.account_number,
          bank_name: this.form.bank_name,
          payreq_type: this.form.payreq_type,
          payment_desc: this.form.payment_desc,
          source_of_funds: this.form.source_of_funds,
          currency: this.form.currency != null ? this.form.currency.symbol : null
        })
        if (this.form.app_category != 2) {
          Object.assign(newForm, {
            global_discount: this.form.global_discount,
            global_discount_percent: this.form.global_discount_percent,
            delivery_costs: this.form.delivery_costs,
            service_costs: this.form.service_costs,
            other_costs: this.form.other_costs,
            pph_percent: this.form.pph_percent,
            pph_amount: this.form.pph_amount,
            addWithoutFpb: true
          })
        }
        if (this.form.vendor_type == 1) {
          Object.assign(newForm, {
            vendor_id: this.form.vendor.id,
            vendor_code: this.form.vendor.code,
            vendor_name: this.form.vendor.name
          })
        } else {
          Object.assign(newForm, {
            vendor_id: null,
            vendor_code: null,
            vendor_name: this.form.vendor_name
          })
        }
        this.submitPayreq(newForm)
      }
    },
    async addToExistingPayreq(form) {
      const xForm = {
        act: 'add_batch',
        payment_request_id: form.payment_request_id,
        items: form.payment_request_detail
      }
      console.log('addBatchToExisting>>>', xForm)

      this.loading = true
      await axios
        .post(`${this.proc}payreq/detail/add_batch`, xForm)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            this.closeDialog()
            setTimeout(() => {
              // this.$store.commit('setFpbId', created_id)
              window.open(
                `/e-catalogue/payreq/detail/${form.payment_request_id}?idx=0`,
                '_blank'
              )
            }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    async submitPayreq(form) {
      this.loading = true
      await axios
        .post(`${this.proc}payreq/save`, form)
        .then((res) => {
          this.loading = false
          if (res.data.status_code == '00') {
            const created_id = res.data.created_id
            console.log(created_id)
            // this.showMsgDialog('success', res.data.status_msg, false)
            this.closeDialog()
            setTimeout(() => {
              // this.$store.commit('setFpbId', created_id)
              this.$router.push(
                `/e-catalogue/payreq/detail/${created_id}?idx=0`
              )
            }, 100)
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    formTypeWatcher() {
      if (this.form != null) {
        if (this.form.app_category == 1) {
          this.form.add_to_existing = false
          Object.assign(this.form, {
            global_discount: 0,
            global_discount_percent: 0,
            delivery_costs: 0,
            service_costs: 0,
            other_costs: 0,
            pph_percent: 0,
            pph_amount: 0
          })
        }
        if (this.form.app_category == 2) {
          this.form.add_to_existing = false
          this.form.payreq_type = 3
          delete this.form.global_discount
          delete this.form.global_discount_percent
          delete this.form.delivery_costs
          delete this.form.service_costs
          delete this.form.pph_percent
          delete this.form.pph_amount
        }
      }
    },
    globalAmountWatcher() {
      if (this.form != null) {
        if (
          this.form.global_discount != null &&
          this.form.global_discount != 0
        ) {
          this.form.global_discount_percent = 0
        }
      }
      return 0
    },
    globalPercentWatcher() {
      if (this.form != null) {
        if (
          this.form.global_discount_percent != null &&
          this.form.global_discount_percent != 0
        ) {
          this.form.global_discount = 0
        }
      }
      return 0
    },

    pphAmountWatcher() {
      if (this.form != null) {
        if (this.form.pph_amount != null && this.form.pph_amount != 0) {
          this.form.pph_percent = 0
        }
      }
      return 0
    },
    pphPercentWatcher() {
      if (this.form != null) {
        if (this.form.pph_percent != null && this.form.pph_percent != 0) {
          this.form.pph_amount = 0
        }
      }
      return 0
    }
  }
}
</script>
